var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablePads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,0L23,0A23,23 0,0 1,46 23L46,23A23,23 0,0 1,23 46L23,46A23,23 0,0 1,0 23L0,23A23,23 0,0 1,23 0z",
    strokeWidth: 1,
    fill: "#F4F5F7",
    stroke: "#EBEBEB",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6727,8L31.5991,8C32.0516,8 32.4477,8.3038 32.565,8.7409L38,29L38,29L8,29L13.7102,8.7289C13.8316,8.2978 14.2249,8 14.6727,8Z",
    strokeWidth: 1,
    fill: "#C0C6CF",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6727,8L18,8L18,8C18.8674,10.7276 20.7008,14.0509 23.5,17.9698C26.2992,21.8887 31.1326,25.5655 38,29L8,29L13.7102,8.7289C13.8316,8.2978 14.2249,8 14.6727,8Z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8,29L38,29L38,34C38,34.5523 37.5523,35 37,35L9,35C8.4477,35 8,34.5523 8,34L8,29L8,29Z",
    strokeWidth: 1,
    fill: "#E25B6E",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,26L11.5,26A0.5,0.5 0,0 1,12 26.5L12,26.5A0.5,0.5 0,0 1,11.5 27L11.5,27A0.5,0.5 0,0 1,11 26.5L11,26.5A0.5,0.5 0,0 1,11.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,22L11.5,22A0.5,0.5 0,0 1,12 22.5L12,22.5A0.5,0.5 0,0 1,11.5 23L11.5,23A0.5,0.5 0,0 1,11 22.5L11,22.5A0.5,0.5 0,0 1,11.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,26L19.5,26A0.5,0.5 0,0 1,20 26.5L20,26.5A0.5,0.5 0,0 1,19.5 27L19.5,27A0.5,0.5 0,0 1,19 26.5L19,26.5A0.5,0.5 0,0 1,19.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,22L19.5,22A0.5,0.5 0,0 1,20 22.5L20,22.5A0.5,0.5 0,0 1,19.5 23L19.5,23A0.5,0.5 0,0 1,19 22.5L19,22.5A0.5,0.5 0,0 1,19.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,26L27.5,26A0.5,0.5 0,0 1,28 26.5L28,26.5A0.5,0.5 0,0 1,27.5 27L27.5,27A0.5,0.5 0,0 1,27 26.5L27,26.5A0.5,0.5 0,0 1,27.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,26L35.5,26A0.5,0.5 0,0 1,36 26.5L36,26.5A0.5,0.5 0,0 1,35.5 27L35.5,27A0.5,0.5 0,0 1,35 26.5L35,26.5A0.5,0.5 0,0 1,35.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,22L27.5,22A0.5,0.5 0,0 1,28 22.5L28,22.5A0.5,0.5 0,0 1,27.5 23L27.5,23A0.5,0.5 0,0 1,27 22.5L27,22.5A0.5,0.5 0,0 1,27.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,26L15.5,26A0.5,0.5 0,0 1,16 26.5L16,26.5A0.5,0.5 0,0 1,15.5 27L15.5,27A0.5,0.5 0,0 1,15 26.5L15,26.5A0.5,0.5 0,0 1,15.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,22L15.5,22A0.5,0.5 0,0 1,16 22.5L16,22.5A0.5,0.5 0,0 1,15.5 23L15.5,23A0.5,0.5 0,0 1,15 22.5L15,22.5A0.5,0.5 0,0 1,15.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,26L23.5,26A0.5,0.5 0,0 1,24 26.5L24,26.5A0.5,0.5 0,0 1,23.5 27L23.5,27A0.5,0.5 0,0 1,23 26.5L23,26.5A0.5,0.5 0,0 1,23.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22L23.5,22A0.5,0.5 0,0 1,24 22.5L24,22.5A0.5,0.5 0,0 1,23.5 23L23.5,23A0.5,0.5 0,0 1,23 22.5L23,22.5A0.5,0.5 0,0 1,23.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,26L31.5,26A0.5,0.5 0,0 1,32 26.5L32,26.5A0.5,0.5 0,0 1,31.5 27L31.5,27A0.5,0.5 0,0 1,31 26.5L31,26.5A0.5,0.5 0,0 1,31.5 26z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,22L31.5,22A0.5,0.5 0,0 1,32 22.5L32,22.5A0.5,0.5 0,0 1,31.5 23L31.5,23A0.5,0.5 0,0 1,31 22.5L31,22.5A0.5,0.5 0,0 1,31.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,22L35.5,22A0.5,0.5 0,0 1,36 22.5L36,22.5A0.5,0.5 0,0 1,35.5 23L35.5,23A0.5,0.5 0,0 1,35 22.5L35,22.5A0.5,0.5 0,0 1,35.5 22z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,24L13.5,24A0.5,0.5 0,0 1,14 24.5L14,24.5A0.5,0.5 0,0 1,13.5 25L13.5,25A0.5,0.5 0,0 1,13 24.5L13,24.5A0.5,0.5 0,0 1,13.5 24z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,24L21.5,24A0.5,0.5 0,0 1,22 24.5L22,24.5A0.5,0.5 0,0 1,21.5 25L21.5,25A0.5,0.5 0,0 1,21 24.5L21,24.5A0.5,0.5 0,0 1,21.5 24z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,24L29.5,24A0.5,0.5 0,0 1,30 24.5L30,24.5A0.5,0.5 0,0 1,29.5 25L29.5,25A0.5,0.5 0,0 1,29 24.5L29,24.5A0.5,0.5 0,0 1,29.5 24z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,24L17.5,24A0.5,0.5 0,0 1,18 24.5L18,24.5A0.5,0.5 0,0 1,17.5 25L17.5,25A0.5,0.5 0,0 1,17 24.5L17,24.5A0.5,0.5 0,0 1,17.5 24z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,24L25.5,24A0.5,0.5 0,0 1,26 24.5L26,24.5A0.5,0.5 0,0 1,25.5 25L25.5,25A0.5,0.5 0,0 1,25 24.5L25,24.5A0.5,0.5 0,0 1,25.5 24z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5,24L33.5,24A0.5,0.5 0,0 1,34 24.5L34,24.5A0.5,0.5 0,0 1,33.5 25L33.5,25A0.5,0.5 0,0 1,33 24.5L33,24.5A0.5,0.5 0,0 1,33.5 24z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,20L13.5,20A0.5,0.5 0,0 1,14 20.5L14,20.5A0.5,0.5 0,0 1,13.5 21L13.5,21A0.5,0.5 0,0 1,13 20.5L13,20.5A0.5,0.5 0,0 1,13.5 20z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16L13.5,16A0.5,0.5 0,0 1,14 16.5L14,16.5A0.5,0.5 0,0 1,13.5 17L13.5,17A0.5,0.5 0,0 1,13 16.5L13,16.5A0.5,0.5 0,0 1,13.5 16z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,20L21.5,20A0.5,0.5 0,0 1,22 20.5L22,20.5A0.5,0.5 0,0 1,21.5 21L21.5,21A0.5,0.5 0,0 1,21 20.5L21,20.5A0.5,0.5 0,0 1,21.5 20z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,16L21.5,16A0.5,0.5 0,0 1,22 16.5L22,16.5A0.5,0.5 0,0 1,21.5 17L21.5,17A0.5,0.5 0,0 1,21 16.5L21,16.5A0.5,0.5 0,0 1,21.5 16z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,20L29.5,20A0.5,0.5 0,0 1,30 20.5L30,20.5A0.5,0.5 0,0 1,29.5 21L29.5,21A0.5,0.5 0,0 1,29 20.5L29,20.5A0.5,0.5 0,0 1,29.5 20z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,16L29.5,16A0.5,0.5 0,0 1,30 16.5L30,16.5A0.5,0.5 0,0 1,29.5 17L29.5,17A0.5,0.5 0,0 1,29 16.5L29,16.5A0.5,0.5 0,0 1,29.5 16z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,20L17.5,20A0.5,0.5 0,0 1,18 20.5L18,20.5A0.5,0.5 0,0 1,17.5 21L17.5,21A0.5,0.5 0,0 1,17 20.5L17,20.5A0.5,0.5 0,0 1,17.5 20z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,16L17.5,16A0.5,0.5 0,0 1,18 16.5L18,16.5A0.5,0.5 0,0 1,17.5 17L17.5,17A0.5,0.5 0,0 1,17 16.5L17,16.5A0.5,0.5 0,0 1,17.5 16z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,20L25.5,20A0.5,0.5 0,0 1,26 20.5L26,20.5A0.5,0.5 0,0 1,25.5 21L25.5,21A0.5,0.5 0,0 1,25 20.5L25,20.5A0.5,0.5 0,0 1,25.5 20z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,16L25.5,16A0.5,0.5 0,0 1,26 16.5L26,16.5A0.5,0.5 0,0 1,25.5 17L25.5,17A0.5,0.5 0,0 1,25 16.5L25,16.5A0.5,0.5 0,0 1,25.5 16z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5,20L33.5,20A0.5,0.5 0,0 1,34 20.5L34,20.5A0.5,0.5 0,0 1,33.5 21L33.5,21A0.5,0.5 0,0 1,33 20.5L33,20.5A0.5,0.5 0,0 1,33.5 20z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5,16L33.5,16A0.5,0.5 0,0 1,34 16.5L34,16.5A0.5,0.5 0,0 1,33.5 17L33.5,17A0.5,0.5 0,0 1,33 16.5L33,16.5A0.5,0.5 0,0 1,33.5 16z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,18L15.5,18A0.5,0.5 0,0 1,16 18.5L16,18.5A0.5,0.5 0,0 1,15.5 19L15.5,19A0.5,0.5 0,0 1,15 18.5L15,18.5A0.5,0.5 0,0 1,15.5 18z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,18L11.5,18A0.5,0.5 0,0 1,12 18.5L12,18.5A0.5,0.5 0,0 1,11.5 19L11.5,19A0.5,0.5 0,0 1,11 18.5L11,18.5A0.5,0.5 0,0 1,11.5 18z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,18L23.5,18A0.5,0.5 0,0 1,24 18.5L24,18.5A0.5,0.5 0,0 1,23.5 19L23.5,19A0.5,0.5 0,0 1,23 18.5L23,18.5A0.5,0.5 0,0 1,23.5 18z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,18L31.5,18A0.5,0.5 0,0 1,32 18.5L32,18.5A0.5,0.5 0,0 1,31.5 19L31.5,19A0.5,0.5 0,0 1,31 18.5L31,18.5A0.5,0.5 0,0 1,31.5 18z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,18L19.5,18A0.5,0.5 0,0 1,20 18.5L20,18.5A0.5,0.5 0,0 1,19.5 19L19.5,19A0.5,0.5 0,0 1,19 18.5L19,18.5A0.5,0.5 0,0 1,19.5 18z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,18L27.5,18A0.5,0.5 0,0 1,28 18.5L28,18.5A0.5,0.5 0,0 1,27.5 19L27.5,19A0.5,0.5 0,0 1,27 18.5L27,18.5A0.5,0.5 0,0 1,27.5 18z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,14L15.5,14A0.5,0.5 0,0 1,16 14.5L16,14.5A0.5,0.5 0,0 1,15.5 15L15.5,15A0.5,0.5 0,0 1,15 14.5L15,14.5A0.5,0.5 0,0 1,15.5 14z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,10L15.5,10A0.5,0.5 0,0 1,16 10.5L16,10.5A0.5,0.5 0,0 1,15.5 11L15.5,11A0.5,0.5 0,0 1,15 10.5L15,10.5A0.5,0.5 0,0 1,15.5 10z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,14L23.5,14A0.5,0.5 0,0 1,24 14.5L24,14.5A0.5,0.5 0,0 1,23.5 15L23.5,15A0.5,0.5 0,0 1,23 14.5L23,14.5A0.5,0.5 0,0 1,23.5 14z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,10L23.5,10A0.5,0.5 0,0 1,24 10.5L24,10.5A0.5,0.5 0,0 1,23.5 11L23.5,11A0.5,0.5 0,0 1,23 10.5L23,10.5A0.5,0.5 0,0 1,23.5 10z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,14L31.5,14A0.5,0.5 0,0 1,32 14.5L32,14.5A0.5,0.5 0,0 1,31.5 15L31.5,15A0.5,0.5 0,0 1,31 14.5L31,14.5A0.5,0.5 0,0 1,31.5 14z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,10L31.5,10A0.5,0.5 0,0 1,32 10.5L32,10.5A0.5,0.5 0,0 1,31.5 11L31.5,11A0.5,0.5 0,0 1,31 10.5L31,10.5A0.5,0.5 0,0 1,31.5 10z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,14L19.5,14A0.5,0.5 0,0 1,20 14.5L20,14.5A0.5,0.5 0,0 1,19.5 15L19.5,15A0.5,0.5 0,0 1,19 14.5L19,14.5A0.5,0.5 0,0 1,19.5 14z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,10L19.5,10A0.5,0.5 0,0 1,20 10.5L20,10.5A0.5,0.5 0,0 1,19.5 11L19.5,11A0.5,0.5 0,0 1,19 10.5L19,10.5A0.5,0.5 0,0 1,19.5 10z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,14L27.5,14A0.5,0.5 0,0 1,28 14.5L28,14.5A0.5,0.5 0,0 1,27.5 15L27.5,15A0.5,0.5 0,0 1,27 14.5L27,14.5A0.5,0.5 0,0 1,27.5 14z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,10L27.5,10A0.5,0.5 0,0 1,28 10.5L28,10.5A0.5,0.5 0,0 1,27.5 11L27.5,11A0.5,0.5 0,0 1,27 10.5L27,10.5A0.5,0.5 0,0 1,27.5 10z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,12L17.5,12A0.5,0.5 0,0 1,18 12.5L18,12.5A0.5,0.5 0,0 1,17.5 13L17.5,13A0.5,0.5 0,0 1,17 12.5L17,12.5A0.5,0.5 0,0 1,17.5 12z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,12L13.5,12A0.5,0.5 0,0 1,14 12.5L14,12.5A0.5,0.5 0,0 1,13.5 13L13.5,13A0.5,0.5 0,0 1,13 12.5L13,12.5A0.5,0.5 0,0 1,13.5 12z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,12L25.5,12A0.5,0.5 0,0 1,26 12.5L26,12.5A0.5,0.5 0,0 1,25.5 13L25.5,13A0.5,0.5 0,0 1,25 12.5L25,12.5A0.5,0.5 0,0 1,25.5 12z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,12L21.5,12A0.5,0.5 0,0 1,22 12.5L22,12.5A0.5,0.5 0,0 1,21.5 13L21.5,13A0.5,0.5 0,0 1,21 12.5L21,12.5A0.5,0.5 0,0 1,21.5 12z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,12L29.5,12A0.5,0.5 0,0 1,30 12.5L30,12.5A0.5,0.5 0,0 1,29.5 13L29.5,13A0.5,0.5 0,0 1,29 12.5L29,12.5A0.5,0.5 0,0 1,29.5 12z",
    strokeOpacity: 0.3,
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "#00000000",
    fillOpacity: 0.3
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3962,24l8.6053,0l1.9984,2l6,0l2.003,-2l8.6539,0l-0.5379,-2l-8.0938,0l-2.0372,2l-5.9939,0l-1.9836,-2l-8.0277,0z",
    strokeWidth: 1,
    fill: "#E25B6E",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0683,11l20.1085,0l0.2641,1l-20.6534,0z",
    strokeWidth: 1,
    fill: "#E25B6E",
    fillRule: "evenodd",
    stroke: "#00000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablePads);
export default __webpack_public_path__ + "static/media/table-pads.e6cb2d20926773873ef6727ae29c17b9.svg";
export { ForwardRef as ReactComponent };